import React from 'react'
import "./Review.css"

const Review = () => {
    return (
        <>

            <section>
                <div className="container-fluid pb-5" style={{ backgroundColor: "#f5f5f5" }}>
                    <div className="CommonPadding">
                        <div className="row d-flex justify-content-center align-items-center Organic-Food-Section-Main-Heading-Top ">
                            <div className='Home-Our-Services-Section-Title'>
                                <h5>
                                    Our Clients Testimonials
                                </h5>
                                <h2>
                                    What our customers are saying about us
                                </h2>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        {/* <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/Review1.jpg")} alt="icloudsoft_logo" />
                                        </div> */}
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                Dia Shirole
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            The experience was really good !!My hair looks great
                                            I don’t regret my decision 
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        {/* <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/Review2.jpg")} alt="icloudsoft_logo" />
                                        </div> */}
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                Snehal Rakshe
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            Madam..the work you have done is very nice and also liked your information.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        {/* <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/Review3.jpg")} alt="icloudsoft_logo" />
                                        </div> */}
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                Siddhi Joshi
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            Nice makeup done for my function in less amount of time.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        {/* <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/Review2.jpg")} alt="icloudsoft_logo" />
                                        </div> */}
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                Dr.Nisha Shah
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            Very elegant work
                                            Nice as person too
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/ClientReview1.png")} alt="icloudsoft_logo" />
                                        </div>
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                Sigma Technologies
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            They are knowledgeable, provide good quotes, get the job
                                            done in a timely manner, and exceed expectations.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className='ClientReviewTop'>
                                    <div className='ClientReview'>
                                        <div className='ClientReviewSectionImge'>
                                            <img src={require("../Img/ClientReview2.png")} alt="icloudsoft_logo" />
                                        </div>
                                        <div className='ClientReviewSection'>
                                            <h3>
                                                TechGen Solutions
                                            </h3>
                                            <h6>
                                                Pune
                                            </h6>
                                            <div>
                                                <ul class="list-unstyled d-flex justify-content-start" style={{ color: "#feda12", fontSize: "10px" }} >
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                    <li className='' ><i class="fas fa-star fa-sm"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='Quama'>
                                            <img src={require("../Img/Quma.png")} alt="icloudsoft_logo" />
                                        </div>
                                    </div>
                                    <div className='ClientReviewBottom'>
                                        <p>
                                            I highly recommend for all your Hydraulic needs. Great service!
                                            Same day the part was delivered with great quality!
                                        </p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Review